import { request, METHOD } from '../utils/request.js'

// 查看绑定学生
export function getChildInfoList(data) {
  return request(
    '/h5Mfitness/parent/getChildInfoList',
    METHOD.POST,
    data
  )
}
// 绑定学生
export function bindStudentInfo(data) {
    return request(
      '/h5Mfitness/parent/bindStudentInfo',
      METHOD.POST,
      data
    )
  }
  

